import { downloadReport } from "../utils/downloadReport ";
import axiosInstance from "./authentication/axiosInstance";

export const documentServices = {

    getAllDocumentByUserId: async (userId) => {
        const response = await axiosInstance.get(`/documents/getAll/${userId}`);
        return response.data;
    },

    getPreviewDocument: async (fieldData) => {
        const response = await axiosInstance.post("/documents/preview", fieldData);
        return response.data;
    },

    generateDocument: async ({ id, userId, documentType, fieldData }) => {
        const response = await axiosInstance.post("/documents/generate",
            { id, userId, documentType, fieldData },
            { responseType: "blob" }
        );

        downloadReport(response);
    },

    getDocumentCount: async (userId, documentType) => {
        const response = await axiosInstance.get(`/documents/count`, {
            params: {
                userId,
                documentType
            }
        }
        );
        return response.data;
    },

    downloadDocument: async ({ id, userId, documentType, fieldData }) => {
        const response = await axiosInstance.post("/documents/download",
            { id, userId, documentType, fieldData },
            { responseType: "blob" }
        );

        downloadReport(response);
    },

    deleteDocument: async (documentId) => {
        const response = await axiosInstance.delete(`/documents/${documentId}`);
        return response.data;
    }

};